<div class="pcheck-card">
  <div class="pcheck-card__header">
    <i class="pi pi-calendar-check" aria-hidden="true"></i>
    <span>Booking Summary — {{ summary.executive_name }}</span>
  </div>
  <div class="pcheck-card__body">

    <!-- Contact details with copy buttons -->
    <table class="meeting-table">
      <tbody>
        <tr class="meeting-table__row">
          <td class="meeting-table__label">First Name</td>
          <td class="meeting-table__value">{{ summary.contact_first_name }}</td>
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(summary.contact_first_name, 'First name')" aria-label="Copy first name">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
        <tr class="meeting-table__row">
          <td class="meeting-table__label">Last Name</td>
          <td class="meeting-table__value">{{ summary.contact_last_name }}</td>
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(summary.contact_last_name, 'Last name')" aria-label="Copy last name">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
        <tr class="meeting-table__row">
          <td class="meeting-table__label">Email</td>
          <td class="meeting-table__value">{{ summary.contact_email }}</td>
          <td class="meeting-table__action">
            <button type="button" class="copy-btn" (click)="onCopy(summary.contact_email, 'Email')" aria-label="Copy contact email">
              <i class="pi pi-copy" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
        @if (summary.account_name) {
          <tr class="meeting-table__row">
            <td class="meeting-table__label">Account</td>
            <td class="meeting-table__value">{{ summary.account_name }}</td>
            <td class="meeting-table__action">
              <button type="button" class="copy-btn" (click)="onCopy(summary.account_name!, 'Account name')" aria-label="Copy account name">
                <i class="pi pi-copy" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        }
        @if (summary.account_external_id || summary.account_id) {
          <tr class="meeting-table__row">
            <td class="meeting-table__label">Account ID</td>
            <td class="meeting-table__value meeting-table__value--mono">{{ summary.account_external_id || summary.account_id }}</td>
            <td class="meeting-table__action">
              <button type="button" class="copy-btn" (click)="onCopy((summary.account_external_id || summary.account_id)!, 'Account ID')" aria-label="Copy account ID">
                <i class="pi pi-copy" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        }
        @if (summary.additional_guests.length) {
          <tr class="meeting-table__row">
            <td class="meeting-table__label">Guests</td>
            <td class="meeting-table__value">{{ summary.additional_guests.join(', ') }}</td>
            <td class="meeting-table__action">
              <button type="button" class="copy-btn" (click)="onCopy(summary.additional_guests.join(', '), 'Guest emails')" aria-label="Copy guest emails">
                <i class="pi pi-copy" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (summary.issue_summary) {
      <div class="booking-summary-card__objective-label">Call objective (for your reference):</div>
      <div class="booking-summary-card__objective">{{ summary.issue_summary }}</div>
    }

    <!-- Action area -->
    @if (confirmed) {
      <div class="pcheck-card__confirmed">
        <i class="pi pi-check-circle" aria-hidden="true"></i> Booking confirmed
      </div>
    } @else if (recoveryPending) {
      <p class="booking-summary-card__recovery-prompt">What would you like to do?</p>
      <div class="pcheck-card__actions">
        <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="retrySameExecutive.emit()">
          <i class="pi pi-refresh" aria-hidden="true"></i> Try again with {{ summary.executive_name }}
        </button>
        <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="tryDifferentExecutive.emit()">
          <i class="pi pi-users" aria-hidden="true"></i> Try a different executive
        </button>
      </div>
    } @else if (!recoveryUsed) {
      <div class="pcheck-card__actions">
        <a class="pcheck-btn pcheck-btn--link" [href]="bookingUrl" target="_blank" rel="noopener noreferrer">
          <i class="pi pi-external-link" aria-hidden="true"></i> Open Booking Page
        </a>
        <button type="button" class="pcheck-btn pcheck-btn--done" (click)="bookingDone.emit()">
          <i class="pi pi-check-circle" aria-hidden="true"></i> I'm Done — Booking Complete
        </button>
        <button type="button" class="pcheck-btn pcheck-btn--neutral" (click)="bookingFailed.emit()">
          <i class="pi pi-times-circle" aria-hidden="true"></i> Booking Not Completed
        </button>
      </div>
    }

  </div>
</div>
